
import {
  all,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { getField } from '../fieldSaga';
import { getPrecPlantingSeasons } from '../precisionPlantingSaga';

import { receiveUserDetails, reqUserDetails } from '../../actions/userActions';
import { getProductAssets } from '../productAssetsSaga';
import { retrievePlantingData } from './retrievePlantingData';
import { retrieveHarvestData } from './retrieveHarvestData';
import { getCropMap } from '../cropSaga';
import { getMosaicData } from '../mosaicSaga';

export function* fieldDeps(fieldLegacyId: string) {
  const { fieldUUID, fieldOwnerId } = yield call(getField, fieldLegacyId);
  const state = yield select();
  const currentUserId = state.currentUser.clientId;
  const { isProxying } = state.user;

  if (!isProxying) {
    if (currentUserId === fieldOwnerId) {
      yield put(receiveUserDetails(state.currentUser, false));
    } else {
      yield put(reqUserDetails(fieldOwnerId));
    }
  }

  const cropsMap = yield call(getCropMap);
  const callSteps = [
    call(getProductAssets, fieldUUID, isProxying ? fieldOwnerId : undefined),
    call(getMosaicData, fieldLegacyId, fieldOwnerId),
    call(getPrecPlantingSeasons, fieldUUID, true),
    call(retrievePlantingData, {fieldUUID, cropsMap}),
    call(retrieveHarvestData, {fieldUUID, cropsMap})
  ];

  const [
    productAssets,
    mosaicData,
    precPlantingSeasons,
    plantingEvents,
    harvestEvents
  ] = yield all(callSteps);

  return {
    harvestSeasons: harvestEvents.harvestSeasons,
    mosaicData,
    plantingSeasons: plantingEvents.plantingSeasons,
    precPlantingSeasons,
    productAssets,
    plantingEvents,
    harvestEvents: harvestEvents.events,
  };
}